import React from "react"
import styled from "styled-components"

import Typography from "@material-ui/core/Typography"

import EmailIcon from "../../../images/email-icon.svg"
import * as theme from "../../../theme"

import Textarea from "./../../textarea"

const ContactInfo = ({ cards }) => {
  return (
    <Container>
      {!!cards &&
        cards.map((card, index) => {
          return (
            <Card key={index}>
              {!!card.name && (
                <Name>
                  <Typography variant="h3" gutterBottom>
                    {card.name}
                  </Typography>
                </Name>
              )}

              {!!card.content && <Textarea content={card.content} />}

              {!!card.job_title && (
                <JobTitle>
                  <Typography variant="body2" gutterBottom>
                    {card.job_title}
                  </Typography>
                </JobTitle>
              )}

              {!!card.contact_numbers && (
                <Numbers>
                  {card.contact_numbers.map((tel, index) => {
                    return (
                      <Tel key={index}>
                        <Type>
                          <Typography variant="h5">
                            {tel.number_type}
                          </Typography>
                        </Type>
                        <Num>
                          <Typography variant="body1">{tel.number}</Typography>
                        </Num>
                      </Tel>
                    )
                  })}
                </Numbers>
              )}
              {!!card.email && (
                <Email href={"mailto:" + card.email}>
                  <Typography
                    variant="h6"
                    color="inherit"
                    className="email-text"
                  >
                    {card.email}
                    <EmailIcon />
                  </Typography>
                </Email>
              )}
            </Card>
          )
        })}
    </Container>
  )
}

export default ContactInfo

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`
const Card = styled.div`
  /* padding-top: 30px; */
  padding-bottom: 20px;
  padding-right: 30px;
  width: 100%;
  @media (min-width: 1050px) {
    width: calc(100% / 2 - 20px);
  }
`

const Name = styled.div`
  text-transform: uppercase;
`
const JobTitle = styled.div`
  /* margin-bottom: 1rem; */
`

const Numbers = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: 22px;
`
const Tel = styled.div`
  padding-right: 55px;
`
const Type = styled.div`
  text-transform: uppercase;
`
const Num = styled.div``

const Email = styled.a`
  display: inline-block;
  text-decoration: none;
  color: ${theme.color.green};
  .email-text {
    display: flex;
    align-items: center;
  }
  svg {
    transition: all 0.3s ease-in-out;
    fill: ${theme.color.green};
    margin-left: 16px;
  }
  &:hover {
    &:after {
      transform: scaleX(1);
    }
  }
  &:after {
    transform-origin: 0 100%;
    display: block;
    content: "";
    border-bottom: solid 2px ${theme.color.green};
    transform: scaleX(0);
    transition: transform 150ms ease-in-out;
  }
`
